import type { ThemeComponents } from './components.types';

export const components: ThemeComponents = {
  leftNavigation: {
    bgColor: '#002924',
    bgColorVariant: 'DARK',
    image: `${process.env.REACT_APP_STATIC_URL}/images/ben-header-logo-mono.svg`,
  },
};

export const componentsHSBC: ThemeComponents = {
  leftNavigation: {
    bgColor: '#F3F3F3',
    bgColorVariant: 'LIGHT',
    image:
      'https://static.thrivebenefits.hsbc.com.sg/images/hsbc-thrive-benefits.png',
  },
};
